
namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
	export class TestGrid extends SiteEntityGrid<TestRow, any> {
        protected getColumnsKey() { return 'Data.Test'; }
        protected getDialogType() { return TestDialog; }
        protected getIdProperty() { return TestRow.idProperty; }
        protected getLocalTextPrefix() { return TestRow.localTextPrefix; }
        protected getService() { return TestService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        getColumns() {
            var columns = super.getColumns();

            var lastResultCode = Q.tryFirst(columns, x => x.field === TestRow.Fields.LastResultCode);
            if (lastResultCode) {
                lastResultCode.format = ctx => {
                    if (!ctx.value)
                        return "";

                    var color;
                    if (ctx.value === "PASS")
                        color = "green";
                    else if (ctx.value == "FAIL")
                        color = "red";
                    else if (ctx.value == "WARN")
                        color = "orange";
                    else if (ctx.value == "IGNORE")
                        color = "gray";
                    else
                        color = "black";

                    return `<span class="text-${color}"><i class="fa fa-dot-circle-o"></i> ${Q.htmlEncode(ctx.value)}</span>`;
                };
            }

            var batch = Q.tryFirst(columns, x => x.field === TestRow.Fields.LastRunBatchId);
            if (batch) {
                batch.format = ctx => {
                    if (!ctx.value)
                        return "";

                    return `<a href="${Q.resolveUrl("~/Data/TestResult")}?batch=${ctx.value}">${Q.htmlEncode(ctx.value)}</a>`;
                }
            }

            columns.splice(5, 0, {
                field: 'Run',
                name: '',
                width: 35,
                minWidth: 35,
                maxWidth: 35,
                format: ctx => `<a class="inline-action run" title="run test"><i class="fa fa-play-circle-o"></i></a>`,
                headerFilterType: Serenity.HeaderFilterType.disabled
            });

            return columns;
        }

        protected onClick(e, row, cell) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as TestRow;
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();
                if (target.hasClass('run')) {
                    TestService.Run({
                        TestCode: item.TestCode
                    }, () => {
                        Q.notifyInfo("Running test " + item.TestCode);
                        this.refresh()
                    });
                }
            }
        }
    }
}